import { render, staticRenderFns } from "./ProductEditFFD.vue?vue&type=template&id=682502c6&"
import script from "./ProductEditFFD.vue?vue&type=script&lang=js&"
export * from "./ProductEditFFD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports